


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const getCusomterSessionReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.CASE_SESSION_CUSTOMERS:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CASE_SESSION_CUSTOMERS_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CASE_SESSION_CUSTOMERS_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
